import React, { useState } from 'react';
import {
Box, Typography, Autocomplete, TextField, Button,Tab,Tabs} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DownloadIcon from '@mui/icons-material/Download';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SpinnerModal from './SpinnerModal';
import { jsPDF } from 'jspdf';

const InformaticaPy = () => {
  const [Sourcedb, setSourcedb] = useState('');
  const [Targetdb, setTargetdb] = useState('');
  const [SourceSearch, setSourceSearch] = useState('');
  const [TargetSearch, setTargetSearch] = useState('');
  const [tabValue, setTabValue] = useState(0);
  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState(null);
  const [result, setResult] = useState('');
  const [downloadLink, setDownloadLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [showSpinnerModal, setShowSpinnerModal] = useState(false);
  const [progress, setProgress] = useState(0);

  const sourceOptions = ['Informatica XML'];
  const targetOptions = ['Python'];
  const dropdownStyle = { width: '300px' };

  const handleTabChange = (event, newValue) => {
  setTabValue(newValue);
  };

  const handleFileUpload = async (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (Sourcedb === 'Informatica XML') {
      if (selectedFiles.length > 0 && selectedFiles[0].name.endsWith('.xml')) {
        setFileName(selectedFiles[0].name);
        setFile(selectedFiles[0]);
        // Upload file to backend
        const formData = new FormData();
        formData.append('file', selectedFiles[0]);
        try {
          await fetch('https://api.elevate.de.ltim.io/informatica_file_upload/', {
            method: 'POST',
            body: formData,
          });
        } catch (error) {
          alert(`Error uploading ${selectedFiles[0].name}: ${error.message}`);
          setFileName('');
          setFile(null);
        }
      } else {
        setFileName('');
        setFile(null);
      }
    }
  };

  const getFileAccept = () => {
    if (Sourcedb === 'Informatica XML') return '.xml';
    return '';
  };

  const handleSubmit = async () => {
    if (!Sourcedb || !file) {
      setResult('Please select source, target and upload the required file.');
      setDownloadLink('');
      setTabValue(1);
      return;
    }

    setShowSpinnerModal(true);
    setProgress(0);
    setLoading(true);
    setResult('');
    setDownloadLink('');

    // Simulate progress
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 200) {
          clearInterval(interval);
          return 200;
        }
        return prev + 10;
      });
    }, 4000);

    // Prepare payload for API
    const payload = {
      xml_file: fileName,
      option_selection: Targetdb,
    };

    try {
      const response = await fetch('https://api.elevate.de.ltim.io/informatica_conversion/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      clearInterval(interval);
      setProgress(100);

      if (!response.ok) {
        const errorData = await response.json();
        setResult(errorData.detail || 'Error occurred, failed to process');
        setDownloadLink('');
        setShowSpinnerModal(false);
        setTabValue(1);
        setLoading(false);
      } else {
        const data = await response.json();
        // Handle code as array or string, and download_link
        if (Array.isArray(data.code)) {
  setResult(data.code.join('\n'));
} else if (typeof data.code === 'string') {
  setResult(data.code);
} else if (data.result) {
  setResult(data.result);
} else if (data.summary) {
  setResult(data.summary); // Show summary if code/result missing
} else {
  setResult('');
}
setDownloadLink(data.download_link || '');
        setTimeout(() => {
          setShowSpinnerModal(false);
          setTabValue(1);
          setLoading(false);
        }, 200);
      }
    } catch (error) {
      clearInterval(interval);
      setShowSpinnerModal(false);
      alert(`Error processing the file: ${error.message}`);
      setTabValue(1);
      setLoading(false);
    }
  };


const handleDownloadCode = () => {
  if (!downloadLink) {
    alert('No download link available.');
    return;
  }
  const anchor = document.createElement('a');
  anchor.href = downloadLink;
  anchor.setAttribute('download', ''); // Let browser use the filename from the server or URL
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};
 const handleDownloadPDF = () => {
  if (!result) {
    alert('No result available to download as PDF.');
    return;
  }
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text('Output', 10, 10);
  const resultContent = String(result);
  doc.setFontSize(11);
  const pageWidth = doc.internal.pageSize.width;
  const margin = 10;
  const contentWidth = pageWidth - margin * 2;
  const lines = doc.splitTextToSize(resultContent, contentWidth);
  let cursorY = 20;
  const lineHeight = 7;
  const pageHeight = doc.internal.pageSize.height;
  lines.forEach((line) => {
    if (cursorY + lineHeight > pageHeight - margin) {
      doc.addPage();
      cursorY = margin;
    }
    doc.text(line, margin, cursorY);
    cursorY += lineHeight;
  });
  doc.save('Output.pdf');
};

  const handleCopyCode = () => {
    if (!result) {
      alert('No API result available to copy.');
      return;
    }
    navigator.clipboard.writeText(result).then(() => {
      alert('Result content copied to clipboard!');
    }).catch((error) => {
      console.error('Failed to copy text:', error);
    });
  };

  return (
 <Box sx={{ width: '100%', marginTop: -7 }}>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        sx={{
          pl: 0,
          '& .MuiTabs-flexContainer': { justifyContent: 'flex-start' },
          '& .MuiTab-root': {
            minWidth: 120,
            fontWeight: 'bold',
            textTransform: 'none',
            paddingRight: 0,
            pl: 0,
          },
        }}
        TabIndicatorProps={{ style: { display: 'none' } }}
      >
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 1 Input */}
              <Box display="flex" alignItems="center">
                <Box
  display="flex"
  alignItems="center"
  justifyContent="center"
  width={24}
  height={24}
  borderRadius="50%"
  bgcolor={result ? "#4caf50" : (tabValue === 0 ? "#1976d2" : "white")}
  border="1.5px solid"
  borderColor={result ? "#4caf50" : (tabValue === 0 ? "#1976d2" : "black")}
  mr={1}
  transition="all 0.2s"
>
  {result ? (
    <CheckCircleIcon sx={{ color: "white", fontSize: 20 }} />
  ) : (
    <Typography variant="subtitle2" sx={{ color: tabValue === 0 ? "white" : "black", fontWeight: 600 }}>1</Typography>
  )}
</Box>
                <Typography
                  sx={{
                    fontWeight: tabValue === 0 ? 700 : 400,
                    color: tabValue === 0 ? "primary.main" : "black",
                    userSelect: "none",
                    transition: "all 0.2s"
                  }}
                >
                  Input
                </Typography>
              </Box>
              {/* Arrow */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 4,
                  ml: 1,
                  mr: 1,
                  mb: 0.6,
                }}
              >
                <Typography sx={{ color: "#bdbdbd", fontWeight: 700, fontSize: 44, lineHeight: 1 }}>
                  &rarr;
                </Typography>
              </Box>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingRight: 0, paddingLeft: 0 }}
        />
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 2 Result */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={24}
                height={24}
                borderRadius="50%"
                bgcolor={tabValue === 1 ? "#1976d2" : "white"}
                border="1.5px solid"
                borderColor={tabValue === 1 ? "#1976d2" : "black"}
                mr={1}
                transition="all 0.2s"
              >
                <Typography variant="subtitle2" sx={{ color: tabValue === 1 ? "white" : "black", fontWeight: 600 }}>2</Typography>
              </Box>
              <Typography
                sx={{
                  fontWeight: tabValue === 1 ? 700 : 400,
                  color: tabValue === 1 ? "primary.main" : "black",
                  userSelect: "none",
                  transition: "all 0.2s"
                }}
              >
                Result
              </Typography>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingLeft: 0 }}
        />
      </Tabs>

      {tabValue === 0 && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              width: '100%',
              gap: 2,
            }}
          >
            {/* Source Dropdown */}
            <Box sx={{ maxWidth: '300px' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                Source<span style={{ color: 'red' }}>*</span>
              </Typography>
              <Autocomplete
                options={sourceOptions}
                value={Sourcedb || ''}
                onChange={(event, newValue) => {
                  setSourcedb(newValue || '');
                  setFileName('');
                  setFile(null);
                }}
                inputValue={SourceSearch}
                onInputChange={(event, newInputValue) => setSourceSearch(newInputValue)}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Source Format" size="small" />
                )}
                sx={dropdownStyle}
              />

              {/* Upload File Button */}
              <Box sx={{ marginTop: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                  {Sourcedb === 'Informatica XML'
                  ? 'Please upload the Informatica XML file'
                  : 'Please upload the file'}<span style={{ color: 'red' }}>*</span>
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  component="label"
                  sx={{
                    backgroundColor: 'white',
                    color: 'black',
                    border: '1px solid black',
                    boxShadow: 'none',
                    height: '40px',
                  }}
                >
                  Upload File
                  <input
                    type="file"
                    hidden
                    accept={getFileAccept()}
                    onChange={handleFileUpload}
                  />
                </Button>
                {fileName && (
                  <Box sx={{ marginTop: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'green' }}>
                      Uploaded File: {fileName}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
            <Box sx={{ maxWidth: '300px', marginRight: '150px' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                Target<span style={{ color: 'red' }}>*</span>
              </Typography>
              <Autocomplete
                options={targetOptions}
                value={Targetdb || ''}
                onChange={(event, newValue) => setTargetdb(newValue || '')}
                inputValue={TargetSearch}
                onInputChange={(event, newInputValue) => setTargetSearch(newInputValue)}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Target Format" size="small" />
                )}
                sx={dropdownStyle}
              />
            </Box>
          </Box>
          {/* Show Submit button only after upload */}
          {fileName && (
            <Box sx={{ display: 'flex', marginTop: 4 }}>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  backgroundColor: 'white',
                  color: 'black',
                  border: '1px solid black',
                  boxShadow: 'none',
                  height: '40px',
                  minWidth: 150
                }}
                onClick={handleSubmit}
                disabled={loading}
              >
                <Typography variant="subtitle1" fontWeight='' fontSize='16px'>
                  SUBMIT
                </Typography>
              </Button>
            </Box>
          )}
        </Box>
      )}

{tabValue === 1 && (
  <Box sx={{ marginTop: 2 }}>
    <Box
      sx={{
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd',
        borderRadius: 2,
        padding: 2,
        marginBottom: 2,
      }}
    >
      <Typography
  variant="body1"
  sx={{
    whiteSpace: 'pre-wrap',
    fontFamily: 'Monospace',
    fontSize: '15px',
    lineHeight: '1.5',
    fontWeightRegular: '500',
  }}
   >
  {result}
  {result && (
    <Box component="span" sx={{ display: 'block', mt: 2, color: 'Black', fontWeight: 600, fontSize: '16px', fontFamily: 'Monospace' }}>
      You can download the improved code using the "Download Code" option below.
    </Box>
  )}
    </Typography>
    </Box>

    {result && (
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
        variant="contained"
        color="primary"
        startIcon={<DownloadIcon />}
        onClick={handleDownloadPDF}
         sx={{
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid black',
              boxShadow: 'none',
            }}
        >
            Download PDF
            
        </Button>
        {downloadLink && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleDownloadCode}
            startIcon={<DownloadIcon />}
            sx={{
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid black',
              boxShadow: 'none',
            }}
          >
            Download Code

          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={handleCopyCode}
          sx={{
            backgroundColor: 'white',
            color: 'black',
            border: '1px solid black',
            boxShadow: 'none',
          }}
          startIcon={<ContentCopyIcon />}
        >
          Copy Code
        </Button>
      </Box>
    )}
  </Box>
   )}


      <SpinnerModal
        open={showSpinnerModal}
        progress={progress}
        inProgressMessage="Result is being generated..."
        successMessage="Result generated successfully!"
        onClose={() => setShowSpinnerModal(false)}
      />
    </Box>
  );
};

export default InformaticaPy;